"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _amber = _interopRequireDefault(require("@material-ui/core/colors/amber"));

var styles = function styles(theme) {
  return {
    root: {},
    gutterBottom: {
      paddingBottom: theme.spacing(4)
    },
    gutterTop: {
      paddingTop: theme.spacing(4)
    },
    title: {},
    icon: {
      paddingRight: theme.spacing(1),
      verticalAlign: "middle"
    },
    message: {},
    warning: {
      color: _amber.default[700]
    },
    error: {
      color: theme.palette.error.dark
    },
    info: {
      color: theme.palette.secondary.main
    }
  };
};

exports.styles = styles;